<template lang="pug">
v-container
  div(v-if="directLink")
    v-card.datacard(flat tile)
      v-row(justify="center").mx-3
        v-card-title().display-1 {{props.title}}
        v-spacer
        v-card-actions()
          tooltip-btn(v-if="props.id" label="View Underlying Dataset Info" icon="mdi-information-outline" icon-large class="mx-1" :to="{name:'dataset',params:{id:props.id},query:{tab:'2'}}")
          tooltip-btn(v-if="props.id" label="View Data Table" icon="mdi-table" icon-large class="mx-1" :to="{name:'dataview',params:{datasetId:props.id}}")
          tooltip-btn(v-if="props.url" label="View API" icon="mdi-code-json" icon-large class="mx-1" :href="props.url" @click.stop)
          tooltip-btn(v-if="props.download" label="Download Full Dataset" icon="mdi-download-outline" icon-large class="mx-1" :href="props.download" @click.stop)
      v-row().ml-8
        div().body-1.font-weight-light {{props.description}}
      v-row().ma-1
        v-card-text()
          component(:is="props.component" v-bind="props.dialog")
          div().caption.font-weight-light.text-center {{props.note}}
  div(v-else)
    v-hover(v-slot:default="{ hover }")
      v-card.datacard.d-flex.flex-column(:to="to" hover :flat="flat" :outlined="outlined" v-on="onVisualization ? {} : { click: () => {dialog = true} }")
        v-card-title(:class="{'pb-0':dense}").d-block.text-center
          .title {{props.title}}
        v-card-text().pb-0
          component(:is="props.component" v-bind="props")
        v-card-actions()
          tooltip-btn(label="Enlarge Visualization" icon="mdi-arrow-expand" @click="dialog=true")
          tooltip-btn(v-if="props.id" label="View Underlying Dataset Info" icon="mdi-information-outline" :to="{name:'dataset',params:{id:props.id},query:{tab:'2'}}")
          tooltip-btn(v-if="props.id" label="View Data Table" icon="mdi-table" :to="{name:'dataview',params:{datasetId:props.id}}")
          tooltip-btn(v-if="props.url" label="View API" icon="mdi-code-json" :href="props.url" @click.stop)
          tooltip-btn(v-if="props.download" label="Download Full Dataset" icon="mdi-download-outline" :href="props.download" @click.stop)
    v-dialog(v-model="dialog" :max-width="1080" :fullscreen="fullscreen" aspect-ratio="1" class="grey lighten-2")
      v-card.datacard(flat tile)
        v-row(justify="center").mx-3
          v-card-title().display-1 {{props.title}}
          v-spacer
          v-card-actions()
            tooltip-btn(v-if="props.id" label="View Underlying Dataset Info" icon="mdi-information-outline" icon-large class="mx-1" :to="{name:'dataset',params:{id:props.id},query:{tab:'2'}}")
            tooltip-btn(v-if="props.id" label="View Data Table" icon="mdi-table" icon-large class="mx-1" :to="{name:'dataview',params:{datasetId:props.id}}")
            tooltip-btn(v-if="props.url" label="View API" icon="mdi-code-json" icon-large class="mx-1" :href="props.url" @click.stop)
            tooltip-btn(v-if="props.download" label="Download Full Dataset" icon="mdi-download-outline" icon-large class="mx-1" :href="props.download" @click.stop)
            tooltip-btn(v-if="!fullscreen" label="View Full Screen" icon="mdi-stretch-to-page-outline" icon-large class="mx-1" @click="fullscreen=true")
            tooltip-btn(v-if="fullscreen" label="Close Full Screen" icon="mdi-close" icon-large class="mx-1" @click="fullscreen=false")
        v-row().ml-8
          div().body-1.font-weight-light {{props.description}}
        v-row().ma-1
          v-card-text()
            component(:is="props.component" v-bind="props.dialog")
            div().caption.font-weight-light.text-center {{props.note}}

</template>

<script>
import TooltipBtn from './TooltipBtn.vue'

export default {
  components: { TooltipBtn },
  props: {
    to: Object,
    rows: String,
    hoverDetails: Boolean,
    showDetails: Boolean,
    showNav: Boolean,
    showViewNav: Boolean,
    flat: Boolean,
    outlined: Boolean,
    dense: Boolean,
    props: Object
  },
  data: () => ({
    dialog: false,
    overlay: false,
    fullscreen: false,
    onVisualization: false,
    directLink: false
  }),
  mounted() {
    if (this.$route.name === 'visualization') {
      this.directLink = true
    }
  },
  methods: {},
  computed: {},
  watch: {}
};
</script>

<style lang="stylus">
.datacard {
  .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .description {
    word-break: normal;
    line-height: 22px;
  }
}
</style>